var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthTrackerEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 61,
    viewBox: "0 0 93 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 27,
    width: 12,
    height: 32,
    fill: "#009589"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 27,
    width: 12,
    height: 8,
    fill: "#67DFD6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 19,
    width: 12,
    height: 40,
    fill: "#009589"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 19,
    width: 12,
    height: 8,
    fill: "#67DFD6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 4,
    width: 12,
    height: 55,
    fill: "#009589"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 4,
    width: 12,
    height: 8,
    fill: "#67DFD6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 19,
    width: 12,
    height: 40,
    fill: "#009589"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 19,
    width: 12,
    height: 8,
    fill: "#67DFD6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 42,
    width: 12,
    height: 17,
    fill: "#009589"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 42,
    width: 12,
    height: 8,
    fill: "#67DFD6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 50,
    r: 10,
    fill: "#EE5588"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.4305 51.9659H84.9702V54.427C84.9702 54.7449 84.7119 55 84.394 55H81.6093C81.2914 55 81.0364 54.7416 81.0364 54.427V51.9659H78.5728C78.255 51.9659 78 51.7075 78 51.3928V48.6072C78 48.2892 78.2583 48.0341 78.5728 48.0341H81.0331V45.573C81.0331 45.2551 81.2914 45 81.606 45H84.3907C84.7086 45 84.9669 45.2584 84.9669 45.573V48.0341H87.4272C87.745 48.0341 88 48.2925 88 48.6072V51.3928C88 51.7108 87.7417 51.9659 87.4272 51.9659",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthTrackerEmpty);
export default __webpack_public_path__ + "static/media/HealthTrackerEmpty.379091ee858a87247756c4bd2c2630cf.svg";
export { ForwardRef as ReactComponent };